import React from 'react';
import { Button } from '@/components/ui/button';
import OnboardingTemplate from '../OnboardingTemplate';

interface CompletionStepProps {
  onComplete: () => void;
  onPrevious: () => void;
}

const CompletionStep: React.FC<CompletionStepProps> = ({ onComplete, onPrevious }) => {
  // Stepper/progress bar content (optional for completion)
  const step = 4; // Adjust according to your step order
  const totalSteps = 4; // Adjust if you have more steps
  const stepperContent = (
    <div className="mb-8">
      <div className="flex items-center mb-2">
        {[...Array(totalSteps)].map((_, i) => (
          <div
            key={i}
            className={`h-1 flex-1 mx-1 rounded ${i < step ? 'bg-orange-500' : 'bg-gray-200'}`}
          />
        ))}
      </div>
      <div className="text-sm text-gray-500 mb-2">Step {step} of {totalSteps}</div>
    </div>
  );

  return (
    <OnboardingTemplate showStepper={true} stepperContent={stepperContent}>
      <div className="text-center md:text-left">
        <h2 className="text-2xl font-bold mb-4">You're fully ready</h2>
        <p className="text-gray-700 mb-8">
          Your profile is live. Feel free to drop by anytime to make tweaks. Welcome aboard and happy connecting
        </p>
        <div className="flex justify-center gap-4">
          <Button className='inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-1/2' variant="outline" onClick={onPrevious}>
            Back
          </Button>
          <Button className='inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-1/2' onClick={onComplete}>
            Start Now
          </Button>
        </div>
      </div>
    </OnboardingTemplate>
  );
};

export default CompletionStep; 